import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { DropdownSelectStyled } from "./styled";
import Select from "react-select";
import theme from "styles/theme.json";
import { useTranslation } from "react-i18next";
import { Icons } from "components";
import { components } from "react-select";

const DropdownSelect = ({
  theme_standard,
  theme_bosendorfer,
  label,
  menuPlacement = "bottom",
  options,
  value,
  onChange,
  onChaneCustom,
  placeholder,
  errors,
  disabled,
  isSplitLabel,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  const isError = !!errors;

  const { t } = useTranslation(["common"]);

  const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        {theme_bosendorfer ? <Icons.ArrowDown /> : <Icons.DropdownArrow />}
      </components.DropdownIndicator>
    );
  };

  const customBosendorferStyles = {
    option: (provided, state) => ({
      ...provided,
      // borderBottom: '1px dotted pink',
      color: state.isSelected ? theme.COLORS.GOLD_2 : theme.COLORS.GOLD_2,
      padding: "8px 10px",
      background: state.isFocused ? "#f2f9fc" : theme.COLORS.WHITE_1,
      fontSize: theme.FONT.SIZE.S14,
      fontFamily: theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR,
    }),
    indicatorSeparator: () => ({
      display: "none", // ซ่อนเส้น Separator (เส้นระหว่าง dropdown กับ text)
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      borderRadius: 0,
      border: isError? `1px solid ${theme.COLORS.RED_1}` : `1px solid ${theme.COLORS.GOLD_2}`,
      padding: "2px 12px 2px 10px",
      width: "calc(100% - 25px)",
      display: "flex",
      background: theme.COLORS.WHITE_1,
      fontSize: theme.FONT.SIZE.S18,
      fontFamily: theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR,
      color: theme.COLORS.GOLD_2,
    }),
    placeholder: (styles) => ({
      ...styles,
      color: theme.COLORS.GOLD_2,
      fontFamily: theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR,
    }),
    singleValue: (provided, state) => {
      const transition = "opacity 300ms";
      return {
        ...provided,
        transition,
        color: theme.COLORS.GOLD_2,
        fontFamily: theme.FONT.STYLE.GLACIAL_INDIFFERENCE_REGULAR,
      };
    },
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      // borderBottom: '1px dotted pink',
      color: state.isSelected ? theme.COLORS.BLACK_4 : theme.COLORS.BLACK_4,
      padding: "8px 10px",
      background: state.isFocused ? "#f2f9fc" : theme.COLORS.WHITE_1,
      fontSize: theme.FONT.SIZE.S14,
    }),
    indicatorSeparator: () => ({
      display: "none", // ซ่อนเส้น Separator (เส้นระหว่าง dropdown กับ text)
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      borderRadius: 21,
      border: isError? `1px solid ${theme.COLORS.RED_1}` : `0.5px solid ${theme.COLORS.PURPLE_11}`,
      padding: "1px 2px 1px 10px",
      width: "calc(100% - 17px)",
      display: "flex",
      background: disabled ? "#EDEDED" : theme.COLORS.WHITE_1,
      fontSize: theme.FONT.SIZE.S14,
      fontFamily: theme.FONT.STYLE.PROMPT_REGULAR,
      color: theme.COLORS.BLACK_4,
    }),
    placeholder: (styles) => ({
      ...styles,
      color: theme.COLORS.GRAY_17,
    }),
    singleValue: (provided, state) => {
      const transition = "opacity 300ms";
      return {
        ...provided,
        transition,
        color: theme.COLORS.BLACK_4,
      };
    },
  };

  return (
    <DropdownSelectStyled>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <Select
          styles={theme_bosendorfer ? customBosendorferStyles : customStyles}
          isDisabled={disabled}
          menuPlacement={menuPlacement}
          options={options}
          onChange={(e) => {
            onChange({
              ...e,
              label: isSplitLabel ? e.label.split(" ")[0] : e.label,
              value: e.value,
            });
            onChaneCustom && onChaneCustom(e);
          }}
          value={value}
          placeholder={placeholder}
          components={{
            DropdownIndicator: CustomDropdownIndicator,
          }}
        />
        {errors && (
          <div className="errors">
            {/* nsSeparator/keySeparator false = ถ้าไม่มีคำแปล จะคืนข้อความเดิม ไม่ถูกตัดที่ : หรือ . */}
            {t(errors, {
              ns: "common",
              nsSeparator: false,
              keySeparator: false,
            })}
          </div>
        )}
      </div>
    </DropdownSelectStyled>
  );
};

DropdownSelect.propTypes = {};

export default DropdownSelect;
